const initState = {}

const organizationReducer = (state = initState, action) => {
  switch (action.type) {
    case "ORG_UPDATE_PROFILE_SUCCESS":
      return {
        ...state,
        message: "Profile Updated Successfully!",
      }
    case "ORG_UPDATE_PROFILE_FAILED":
      return {
        ...state,
        message: "Failed to Update Profile!",
      }
    case "UPDATE_PROFILE_PICTURE_SUCCESS":
      return {
        ...state,
        message: "Profile Picture Updated Successfully!",
      }
    case "UPDATE_PROFILE_PICTURE_FAILED":
      return {
        ...state,
        message: "Failed to Update Profile Picture!",
      }
    default:
      return state
  }
}

export default organizationReducer
